import { Stack } from '@chakra-ui/react';
import { useParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';

import { routes } from '@blockpulse3/data/shared';
import { LinkButton } from '@blockpulse3/ui/commons';

import { FundraisingHeader } from './FundraisingHeader';
import { FundraisingInformations } from './FundraisingInformations';
import { FundraisingProgression } from './FundraisingProgression';
import { FundraisingStatusAlert } from './FundraisingStatusAlert';
import { FundraisingSubscribersList } from './FundraisingSubscribersList/FundraisingSubscribersList';
import { FundraisingUploadCertificate } from './FundraisingUploadCertificate';

type Props = {
  backHref?: string;
};

/**
 * FundraisingView.
 * View of a Fundraising.
 *
 * @returns {JSX.Element}
 */
export function FundraisingView({ backHref }: Props): JSX.Element {
  const i18nFundraising = useTranslations('Fundraising');

  const { companyId = '' } = useParams();

  const workspaceRoute = companyId ? routes.workspace.fmt(companyId) : routes.home.href;
  const routeBack = backHref ? backHref : workspaceRoute;

  return (
    <Stack spacing="6">
      <LinkButton label={i18nFundraising('LinkDashboard')} route={routeBack} />
      <FundraisingHeader />
      <FundraisingUploadCertificate />
      <FundraisingStatusAlert />
      <FundraisingProgression />
      <FundraisingInformations />
      <FundraisingSubscribersList />
    </Stack>
  );
}

export type FundraisingViewProps = Props;
